export default "__VITE_ASSET__B$PwAbSc__"